import React, { useEffect, useState } from "react";
import DialogBox from "../../components/Comman/dialog-box/DialogBox";
import style from "./aiDash.module.css";
import buttonData from "./button.json";
import AssignedCampaign from "./AssignedCampaign";
import StructureCreator from "./StructureCreator";
import { useDispatch } from "react-redux";
import { AI_ACTION_TYPES } from "../../redux/actions/actions_ai_type";
import AgentCreation from "./AgentCreation";
import { UserPlus, Link2, Layers3 } from "lucide-react";
import { motion } from "framer-motion";

const AI_SAAS = () => {
  const [activeTab, setActiveTab] = useState(buttonData.buttons[0].name);
  const [showDialog, setShowDialog] = useState(false);

  const handleUpdateAgentStructureData = () => {
    return (dispatch) => {
      dispatch({
        type: AI_ACTION_TYPES.ONGOING_AGENTID,
        payload: "",
      });
      dispatch({
        type: AI_ACTION_TYPES.CHECK_DATA_STRUCTURE_BY_AI_ID,
        payload: null,
      });
    };
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    dispatch(handleUpdateAgentStructureData());
  };

  const dispatch = useDispatch();

  const handleSetAiDataNull = () => {
    return (dispatch) => {
      dispatch({
        type: AI_ACTION_TYPES.SET_HEADER_DATA_NULL,
      });
      dispatch({
        type: AI_ACTION_TYPES.SET_BODY_DATA_NULL,
      });
      dispatch({
        type: AI_ACTION_TYPES.SET_FOOTER_DATA_NULL,
      });
    };
  };

  const handleCloseDialog = (tab) => {
    setShowDialog(false);
    setActiveTab(tab);
    dispatch(handleSetAiDataNull());
    dispatch(handleUpdateAgentStructureData());
    localStorage.removeItem("updatingAgentId");
  };

  useEffect(() => {
    if (localStorage.getItem("updatingAgentId")) {
      window.location.reload(localStorage.removeItem("updatingAgentId"));
    }
    localStorage.removeItem("loading");
    localStorage.removeItem("uiType")
    localStorage.removeItem("campaignId")
    localStorage.removeItem("campaign_name")
    localStorage.removeItem("campaign_type")
  }, []);

  const iconMap = {
    UserPlus: <UserPlus size={18} />,
    Link2: <Link2 size={18} />,
    Layers3: <Layers3 size={18} />
  };


  return (
    <>
      <div className={style.container_ai}>
        {buttonData.buttons.map((button, index) => (
          <motion.div
            key={index}
            className={`${style.tab_btn} ${activeTab === button.name ? "" : style.active
              }`}
            onClick={() => handleTabClick(button.name)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {iconMap[button.icon]}
              {button.name}
            </span>
          </motion.div>
        ))}
      </div>

      <DialogBox
        activeTab={activeTab}
        open={showDialog}
        handleCloseDialog={() => handleCloseDialog(activeTab)}
      />
      {activeTab === "Assign Campaign" && (
        <AssignedCampaign
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setShowDialog={setShowDialog}
          handleCloseDialog={handleCloseDialog}
        />
      )}
      {activeTab === "Structure Creator" && (
        <StructureCreator
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setShowDialog={setShowDialog}
          handleCloseDialog={handleCloseDialog}
        />
      )}
      {activeTab === "Agent Creation" && (
        <AgentCreation
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setShowDialog={setShowDialog}
          handleCloseDialog={handleCloseDialog}
        />
      )}
    </>
  );
};

export default AI_SAAS;
